<template>
  <div class="content__title">
    <slot/>
  </div>
</template>
<script>
export default {}
</script>
